import { defineStore } from 'pinia'
import dayjs from 'dayjs'

interface ExpectedTemplate {
  arr: string[]
  unix: number
}

const today = dayjs().startOf('d').unix()
const useStore = defineStore('default', {
  state: () => ({
    /** 今日已点赞、期待底板 */
    todayExpectedTemplate: [] as string[]
  }),
  actions: {
    setTodayExpectedTemplate(value: string[]) {
      this.todayExpectedTemplate = value
      const newExpectedTemplate: ExpectedTemplate = { arr: value, unix: today }
      localStorage.setItem('expectedTemplate', JSON.stringify(newExpectedTemplate))
    }
  }
})
export default useStore

export function useInitDefaultStore() {
  const store = useStore()
  const expectedTemplate: ExpectedTemplate = JSON.parse(localStorage.getItem('expectedTemplate') || '{}')
  if (expectedTemplate.unix === today) {
    store.todayExpectedTemplate = expectedTemplate.arr
  }
}
